import { FilterHandler } from '@btime/react-contexts'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useFormState } from '../../../packages/kiti/components/form/form/FormHandler'
import Form from '../../../packages/kiti/components/form/form/Form'
import Line from '../../../packages/kiti/components/helpers/Line'
import Modal from '../../../components/structure/Modal'
import ModalPickerFooter from '../../../components/form/modalPicker/ModalPickerFooter'
import ModalPickerHeader from '../../../components/form/modalPicker/ModalPickerHeader'
import Picker from '../../../packages/kiti/components/form/picker/Picker'
import Scroll from '../../../packages/kiti/components/helpers/Scroll'
import SelectableListItem from '../../../packages/kiti/components/list/SelectableListItem'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import MapPointLoader, { useMapPoints } from './_load/MapPointLoader'

const Footer = ({ onClose, onChange }) => {
  return <ModalPickerFooter closeModal={onClose} onChange={onChange} />
}

const Content = props => {
  const options = useMapPoints()
  const { form, handleChangeIn } = useFormState()

  return (
    <Picker
      Selector={SelectableListItem}
      options={options}
      value={form || []}
      onChange={handleChangeIn([])}
      idField="id"
      labelField="name"
      descriptionField="email"
      {...props}
    />
  )
}

const MapPointPickerModal = ({ open, onClose, value, onChange, level, ...props }) => {
  const { t } = useTranslation('users')

  return (
    <Modal width="32rem" noPadding open={open} onClose={() => onClose()} level={level} zIndex={1000}>
      <FilterHandler>
        <Form initialState={value || []}>
          <ModalPickerHeader title={t('selectUsers')} {...props} />
          <Line />

          <Scroll height="65vh">
            <MapPointLoader>
              <Content closeModal={onClose} {...props} />
            </MapPointLoader>
            <Separator weight={12} />
          </Scroll>

          <Line />
          <Footer onClose={onClose} onChange={onChange} {...props} />
        </Form>
      </FilterHandler>
    </Modal>
  )
}

export default MapPointPickerModal
